// extracted by mini-css-extract-plugin
module.exports = {"islandGrid":"island_islandGrid__3dtTB","islandsWrapper":"island_islandsWrapper__Yfypf","Capa1":"island_Capa1__11H0P"};